const EventEmitter = require('events').EventEmitter
var moment = require('moment')
moment.locale('it')
import axios from './tAxios'
import storage from './tStorage'

import dbItem from './dbItem'


class partecipante{
   constructor (args) {
      this.event = new EventEmitter()
      this.moment = moment
      this.contatto = new dbItem({database:'ccb_20211105',table:'contatto'})
      this.maxPartecipanti=190

      this.contatto.event.on('loaded', () =>{
         storage.save('partecipante',this.contatto.row.id)
         //this.init()         
      })
      
      return this
   }
   
   async init(){
      await axios.query('query',`UPDATE statoiscrizione SET dbaction=1 WHERE dbaction=-1;`)
      return new Promise(async (resolve, reject) => {
         
         resolve("Fatto")
      })
   }

   checkEmail(emailCheck){
      return new Promise((resolve, reject) => {
         axios.query('fetchOne',`SELECT email FROM contatto WHERE email=→email AND step>0 LIMIT 1`,{email:emailCheck}).then((response) => {
          var controllo = (response.result == emailCheck) ? false : true
          resolve(controllo)
        })
      })
   }


   checkCodicefiscale(codicefiscaleCheck){
      return new Promise((resolve, reject) => {
         axios.query('fetchOne',`SELECT codicefiscale FROM contatto WHERE codicefiscale=→codicefiscale AND step>1 LIMIT 1`,{codicefiscale:codicefiscaleCheck}).then((response) => {
          var controllo = (response.result == codicefiscaleCheck) ? false : true
          resolve(controllo)
        })
      })
   }

   checkPartecipanti(){
      return new Promise((resolve, reject) => {
         axios.query('fetchOne',`SELECT COUNT(*) FROM contatto WHERE step>0 AND id>0`,{}).then((response) => {
          var controllo = (this.maxPartecipanti-response.result >0) ?  true : false
          resolve(controllo)
        })
      })
   }



}
export default new partecipante
